import { Component, Input } from '@angular/core';
import { Voicemaildto } from '../../generated/eveportal-api/graphql';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { SipService } from '../services/sip.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-call-history-voicemail-card',
  templateUrl: './call-history-voicemail-card.component.html',
  styleUrls: ['./call-history-voicemail-card.component.css']
})
export class CallHistoryVoicemailCardComponent {
  @Input() voicemail!: Voicemaildto;

  
  public audioBlobUrl: SafeResourceUrl | null = null;
  isLoading = false;

  /**
   *
   */
  constructor(
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private sipService: SipService,
    private snack: MatSnackBar
  ) {}

  get displayName(): string {
    return this.voicemail.remoteParty?.displayName || this.voicemail.remoteParty?.number || 'Unknown';
  }

  get formattedDate(): string {
    return new Date(this.voicemail.startTime!).toLocaleString();
  }

  downloadAndPlay() {
    if (!this.voicemail.url) return;

    this.isLoading = true;

    const base = environment.config.system.evePortalApiUrl; // 🔁 Replace with your actual base
    const endpoint = `${base}/UserCommunicationLog/DownloadVoicemail?url=${encodeURIComponent(this.voicemail.url)}`;

    try {
      this.http.get(endpoint, { observe: 'response', responseType: 'blob' }).subscribe(response => {
        const type = response.headers.get('Content-Type') || 'audio/wav';
        const blob = new Blob([response.body!], { type });
        const url = URL.createObjectURL(blob);
      
        this.audioBlobUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        console.log('📦 Sanitized Blob URL:', this.audioBlobUrl);
      });
    
    } catch (err: any) {
      console.error('❌ Failed to load voicemail:', err);
      this.audioBlobUrl = null;
      const errorMessage = "Failed to load voicemail: " + (err instanceof Error ? err.message : 'Unknown error');
      this.snack.open(errorMessage, 'Dismiss');
    } finally {
      this.isLoading = false;
    }
  }

  
  async callBack() {
    try {
      const target = this.voicemail.remoteParty?.number;
      if (target) {
        await this.sipService.makeCall(target);
      } else {
        console.warn('📵 No valid number to call back.');
      }
    } catch (error: any) {
      const errorMessage = "Failed to call back: " + error.message;
      this.snack.open(errorMessage, 'Dismiss');
    }
  }
}
